module.exports = __webpack_public_path__ + "media/bootstrap-icons/bucket-fill-7b6a359d.svg";